import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldBase } from '@nagel-types';

@Component({
    selector: 'lib-app-base-field',
    providers: [],
    imports: [],
    templateUrl: './base-field.component.html',
    styleUrl: './base-field.component.scss'
})
export class BaseFieldComponent {
  @Input() field!: FieldBase<unknown>;
  @Input() form?: FormGroup;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public isApplicable(fieldType: string) {
      return true;
  }
}